/* eslint-disable import/no-default-export */
import classnames from 'classnames';
import React from 'react';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

// eslint-disable-next-line no-restricted-imports
import Collapsible from 'components/collapsible';
// eslint-disable-next-line no-restricted-imports
import {
  BoardStarUpdate,
  showLessActiveBoards,
  State,
  updateBoardStarPosition,
} from 'modules';
// eslint-disable-next-line no-restricted-imports
import { MemberContext, MemberInfo } from 'modules/context';
// eslint-disable-next-line no-restricted-imports
import { BoardsMenuCategoryModel, BoardsMenuCategoryType } from 'types/models';
import CategoryContent from './category-content';

import styles from './boards-menu.less';

const icons = {
  [BoardsMenuCategoryType.Starred]: 'star',
  [BoardsMenuCategoryType.Recent]: 'clock',
  [BoardsMenuCategoryType.Personal]: 'board',
  [BoardsMenuCategoryType.Team]: 'organization',
};

// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
const format = forTemplate('boards_sidebar_section');
const formatBoardsList = forTemplate('board_list');

interface OwnProps {
  categories: BoardsMenuCategoryModel[];
  hidden: boolean;
}

interface DispatchProps {
  includeLessActiveBoards: (
    idTeam: string,
    e: React.MouseEvent<HTMLButtonElement>,
  ) => void;
  reorderBoards: (data: BoardStarUpdate) => void;
}

interface AllProps extends OwnProps, DispatchProps {}

const BoardList: React.FunctionComponent<AllProps> = ({
  categories,
  includeLessActiveBoards,
  reorderBoards,
  hidden,
}) => (
  <MemberContext.Consumer>
    {(memberInfo: MemberInfo) => {
      return (
        <div className={styles.boards} hidden={hidden}>
          {categories.map((categoryModel) => {
            const {
              boards,
              category,
              type,
              id,
              numLessActiveBoards = 0,
              logos,
              isPremiumTeam,
              url,
            } = categoryModel;

            const isStarredType = type === BoardsMenuCategoryType.Starred;
            const hasBoards = !!boards.length;

            if (!isStarredType && !hasBoards) {
              return null;
            }

            const isTeam = type === BoardsMenuCategoryType.Team;
            const headerClass = isTeam
              ? classnames(styles.collapsibleHeader, styles.teamHeader)
              : styles.collapsibleHeader;
            const avatarURL = isTeam && !!logos ? logos['30'] : null;
            const titleClass = classnames(
              isTeam && styles.teamName,
              avatarURL && styles.hasAvatar,
            );
            const idTeam = isTeam
              ? id.replace(`${BoardsMenuCategoryType.Team}-`, '')
              : id;

            const onDragEnd = (result: DropResult) => {
              const { draggableId, source, destination } = result;
              if (
                // they didn't drop it on a droppable
                !destination ||
                // they dropped it in the same position
                (destination.droppableId === source.droppableId &&
                  destination.index === source.index)
              ) {
                return;
              }

              if (memberInfo.id) {
                reorderBoards({
                  idBoard: draggableId,
                  idMember: memberInfo.id,
                  position: destination.index,
                });
              }
            };

            return (
              <DragDropContext key={id} onDragEnd={onDragEnd}>
                <Collapsible
                  key={`category-${id}`}
                  avatarURL={avatarURL}
                  icon={icons[type]}
                  id={idTeam}
                  url={url}
                  categoryId={id}
                  showPremiumIndicator={isPremiumTeam}
                  title={category}
                  open={true}
                  headerClass={headerClass}
                  tabIndex={-1}
                  titleClass={titleClass}
                  toggleClass={styles.collapsibleToggle}
                >
                  {isStarredType &&
                    !hasBoards && (
                      <div className={styles.starredBoardsEmptyState}>
                        {format('star-your-most-important-boards')}
                      </div>
                    )}
                  <CategoryContent {...categoryModel} />
                  {numLessActiveBoards > 0 && (
                    <div>
                      <button
                        onClick={includeLessActiveBoards.bind(null, idTeam)}
                        className={classnames(
                          styles.quietButton,
                          styles.showLessActive,
                        )}
                      >
                        {formatBoardsList('show-less-active-boards-count', {
                          lessActiveCount: numLessActiveBoards.toString(),
                        })}
                      </button>
                    </div>
                  )}
                </Collapsible>
              </DragDropContext>
            );
          })}
        </div>
      );
    }}
  </MemberContext.Consumer>
);

const mapDispatchToProps = (dispatch: Dispatch<State>): DispatchProps => {
  return {
    includeLessActiveBoards(idTeam, e) {
      e.preventDefault();
      dispatch(showLessActiveBoards(idTeam));

      Analytics.trackUE({
        category: Noun.BOARDS_MENU,
        verb: Verb.SHOWS,
        directObj: Noun.LESS_ACTIVE_BOARDS,
        context: {
          teamID: idTeam,
        },
      });
    },

    reorderBoards(data) {
      dispatch(updateBoardStarPosition(data));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps,
)(BoardList);



// WEBPACK FOOTER //
// ./app/gamma/src/components/popovers/boards-menu/board-list.tsx